<template>
  <div class="home-route-search-container">
    <el-autocomplete
      ref="autocomplete"
      v-model="query"
      :fetch-suggestions="querySearch"
      placeholder="Buscar tela ou explorar tipos... (ex: serviços, agenda, cobrança)"
      :trigger-on-focus="true"
      :clearable="true"
      size="medium"
      class="home-route-autocomplete"
      popper-class="home-route-popper"
      @select="handleSelect"
      @keyup.enter.native="handleEnter"
      @focus="handleFocus"
    >
      <i slot="prefix" class="el-input__icon el-icon-search search-icon-primary"></i>

      <template slot-scope="{ item }">
        <!-- Item de Carregar Mais / Lazy Loading -->
        <div
          v-if="item.isLoadMore"
          class="load-more-row py-2 text-center text-primary font-medium text-xs flex items-center justify-center cursor-pointer hover:bg-blue-50"
        >
          <i :class="isLoadingMore ? 'el-icon-loading' : 'el-icon-arrow-down'" class="mr-2 text-sm"></i>
          <span>{{ item.text }}</span>
        </div>

        <!-- Item de Cabeçalho / Divisor de Seção -->
        <div
          v-else-if="item.isHeader"
          class="browse-header-row py-1 px-2 text-xs font-bold text-gray-500 uppercase tracking-wider flex items-center bg-gray-50 rounded my-1"
        >
          <i :class="item.icon" class="mr-1 text-primary"></i>
          <span>{{ item.title }}</span>
        </div>

        <!-- Item de Rota Normal -->
        <div
          v-else
          class="route-item-row flex items-center justify-between py-2 border-b border-gray-100 last:border-b-0"
        >
          <div class="flex items-center truncate mr-3">
            <span class="route-icon-box mr-3 flex items-center justify-center">
              <i :class="item.elIcon || 'el-icon-document'" class="text-base text-primary"></i>
            </span>
            <div class="truncate">
              <div class="route-title font-semibold text-sm text-gray-800 leading-snug truncate">
                {{ item.name }}
              </div>
              <div class="route-desc text-xs text-gray-500 leading-snug truncate">
                {{ item.description || item.path }}
              </div>
            </div>
          </div>

          <div class="flex items-center flex-shrink-0">
            <span v-if="item.isRecent" class="recent-pill mr-2 text-xs text-gray-400">
              <i class="el-icon-time mr-1"></i>Recente
            </span>
            <span :class="['category-pill', getCategoryBadgeClass(item.category)]">
              {{ item.category }}
            </span>
          </div>
        </div>
      </template>
    </el-autocomplete>
  </div>
</template>

<script>
import {
  searchSystemRoutes,
  getRecentSearches,
  saveRecentSearch,
  getBrowsableRoutes
} from "@/constants/systemRoutes";


export default {
  name: "HomeRouteSearch",
  data() {
    return {
      query: "",
      browsePage: 1,
      browsePageSize: 10,
      activeCb: null,
      currentSuggestions: [],
      isLoadingMore: false,
      hasMore: false,
      scrollContainer: null
    };
  },
  methods: {
    permissoes() {
      return this.$atividades && this.$atividades.permissoes;
    },
    querySearch(queryString, cb) {
      this.activeCb = cb;

      if (!queryString || queryString.trim() === "") {
        this.browsePage = 1;
        this.buildBrowseSuggestions();
        cb(this.currentSuggestions);
        this.$nextTick(this.attachScrollListener);
        return;
      }

      this.detachScrollListener();
      var results = searchSystemRoutes(queryString, 8, this.permissoes());
      this.currentSuggestions = results;
      cb(results);
    },
    buildBrowseSuggestions() {
      var paged = getBrowsableRoutes({
        page: this.browsePage,
        pageSize: this.browsePageSize,
        permissoes: this.permissoes()
      });
      this.hasMore = paged.hasMore;

      var list = [];
      if (this.browsePage === 1) {
        var recents = getRecentSearches(this.permissoes());
        if (recents && recents.length > 0) {
          list.push({ isHeader: true, title: "Telas Recentes", icon: "el-icon-time" });
          for (var i = 0; i < recents.length; i++) {
            list.push(recents[i]);
          }
          list.push({ isHeader: true, title: "Todas as Telas por Tipo", icon: "el-icon-menu" });
        }
      } else {
        list = this.currentSuggestions.filter(function(item) {
          return !item.isLoadMore;
        });
      }

      for (var j = 0; j < paged.items.length; j++) {
        var item = paged.items[j];
        var alreadyExists = list.some(function(existing) {
          return existing.name === item.name && existing.path === item.path;
        });
        if (!alreadyExists) {
          list.push(item);
        }
      }

      if (this.hasMore) {
        var shownCount = this.browsePage * this.browsePageSize;
        list.push({
          isLoadMore: true,
          text: "Carregar mais telas... (mostrando " + Math.min(shownCount, paged.total) + " de " + paged.total + ")"
        });
      }

      this.currentSuggestions = list;
    },
    loadMoreSuggestions() {
      if (!this.hasMore || this.isLoadingMore) return;
      this.isLoadingMore = true;
      this.browsePage += 1;

      var self = this;
      setTimeout(function() {
        self.buildBrowseSuggestions();
        self.isLoadingMore = false;
        if (self.activeCb) {
          self.activeCb(self.currentSuggestions);
        }
        if (self.$refs.autocomplete) {
          self.$refs.autocomplete.suggestions = self.currentSuggestions;
        }
      }, 120);
    },
    attachScrollListener() {
      var popper = document.querySelector(".home-route-popper .el-autocomplete-suggestion__wrap");
      if (popper && !this.scrollContainer) {
        this.scrollContainer = popper;
        popper.addEventListener("scroll", this.handlePopperScroll);
      }
    },
    detachScrollListener() {
      if (this.scrollContainer) {
        this.scrollContainer.removeEventListener("scroll", this.handlePopperScroll);
        this.scrollContainer = null;
      }
    },
    handlePopperScroll(event) {
      var target = event.target || this.scrollContainer;
      if (!target) return;
      if (target.scrollTop + target.clientHeight >= target.scrollHeight - 50) {
        if (this.hasMore && !this.isLoadingMore && (!this.query || this.query.trim() === "")) {
          this.loadMoreSuggestions();
        }
      }
    },
    handleSelect(item) {
      if (!item) return;

      if (item.isLoadMore) {
        this.loadMoreSuggestions();
        return;
      }

      if (item.isHeader) {
        return;
      }

      saveRecentSearch(item);
      this.query = "";
      this.detachScrollListener();

      if (this.$route && this.$route.path !== item.path) {
        this.$router.push(item.path);
      }
      this.$emit("navigated", item);
    },
    handleFocus() {
      this.$nextTick(this.attachScrollListener);
    },
    handleEnter() {
      if (!this.query || this.query.trim() === "") return;
      var results = searchSystemRoutes(this.query, 1, this.permissoes());
      if (results && results.length > 0) {
        this.handleSelect(results[0]);
      }
    },
    getCategoryBadgeClass(category) {
      switch (category) {
        case "COMERCIAL":
          return "cat-comercial";
        case "PCO":
          return "cat-pco";
        case "FINANCEIRO":
          return "cat-financeiro";
        case "DASHBOARDS":
          return "cat-dashboards";
        case "CONFIGURAÇÕES":
        case "CADASTROS":
          return "cat-config";
        default:
          return "cat-default";
      }
    }
  },
  beforeDestroy() {
    this.detachScrollListener();
  }
};

</script>

<style lang="scss">
.home-route-search-container {
  width: 100%;
  max-width: 380px;

  .home-route-autocomplete {
    width: 100%;

    .el-input__inner {
      border-radius: 9999px !important;
      padding-left: 38px !important;
      padding-right: 32px !important;
      background-color: #ffffff;
      border: 1px solid #dcdfe6;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
      transition: all 0.2s ease-in-out;
      font-size: 13px;
      height: 40px;
      line-height: 40px;

      &:focus {
        border-color: #083357 !important;
        box-shadow: 0 3px 12px rgba(8, 51, 87, 0.15);
      }
    }

    .search-icon-primary {
      color: #083357 !important;
      font-weight: bold;
      font-size: 16px;
      line-height: 40px;
    }
  }
}

.home-route-popper {
  min-width: 380px !important;
  max-width: 520px !important;
  border-radius: 8px !important;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12) !important;
  border: 1px solid #e4e7ed !important;

  .el-autocomplete-suggestion__wrap {
    padding: 6px 0;
    max-height: 360px;
  }

  .el-autocomplete-suggestion li {
    padding: 4px 14px;
    line-height: normal;

    &:hover,
    &.highlighted {
      background-color: #f0f7ff !important;
    }
  }

  .route-icon-box {
    width: 28px;
    height: 28px;
    background-color: #e8f1fa;
    border-radius: 6px;
    flex-shrink: 0;

    i {
      color: #083357 !important;
    }
  }

  .recent-pill {
    font-size: 11px;
    color: #909399;
  }

  .category-pill {
    font-size: 10px;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 4px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
  }

  .cat-comercial {
    background-color: #e6f7ff;
    color: #0070cc;
    border: 1px solid #bae7ff;
  }

  .cat-pco {
    background-color: #f6ffed;
    color: #389e0d;
    border: 1px solid #b7eb8f;
  }

  .cat-financeiro {
    background-color: #fff7e6;
    color: #d46b08;
    border: 1px solid #ffd591;
  }

  .cat-dashboards {
    background-color: #f9f0ff;
    color: #722ed1;
    border: 1px solid #d3adf7;
  }

  .cat-config {
    background-color: #f5f5f5;
    color: #595959;
    border: 1px solid #d9d9d9;
  }

  .cat-default {
    background-color: #eef2f5;
    color: #475569;
  }
}
</style>
